export default __webpack_public_path__ + "static/media/retirement.b1a804d4.svg";